import PropTypes from 'prop-types'
import React from 'react'
import { Link, Icon, AppliedFilters } from 'Blocks'
import get from 'lodash/get'
import { UrlBuilder } from 'Utils'
import config from 'Config'

const MobileRefineView = props => {
  const setActiveView = activeView => {
    const builder = new UrlBuilder(props.queryString)
    return builder.setDialogView(activeView).getQueryString()
  }

  const isSearch = props.queryString.indexOf('term') > -1
  const colorData = get(
    props,
    'data.products.categories.current.filters[0].values',
    []
  )
  const hasColors = colorData.length > 0

  return (
    <div className="filter-panel__menu panel">
      <AppliedFilters />
      {config.filters.departments.enabled && isSearch && (
        <Link to={setActiveView('Department')}>
          <div className="menu__item">Department</div>
          <Icon className="icon_arrow_right" name="keyboard_arrow_right" />
        </Link>
      )}
      <Link to={setActiveView('SortBy')}>
        <div className="menu__item">Sort by</div>
        <Icon className="icon_arrow_right" name="keyboard_arrow_right" />
      </Link>
      <Link to={setActiveView('Price')}>
        <div className="menu__item">Price</div>
        <Icon className="icon_arrow_right" name="keyboard_arrow_right" />
      </Link>
      {config.filters.colors.enabled && hasColors && (
        <Link to={setActiveView('Colours')}>
          <div className="menu__item">Colours</div>
          <Icon className="icon_arrow_right" name="keyboard_arrow_right" />
        </Link>
      )}
      <Link to={setActiveView('Stores')}>
        <div className="menu__item">Stores</div>
        <Icon className="icon_arrow_right" name="keyboard_arrow_right" />
      </Link>
    </div>
  )
}

MobileRefineView.propTypes = {
  queryString: PropTypes.string
}

export default MobileRefineView
